import "./i18n-setup";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { DehubThemeProvider, ModalsProvider, Notifications } from "@dehub/theme";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import { invoiceThemeOverride } from "./theme/invoice-theme";
import "./styles/base.css";
import "./styles/global.css";

const basePath = (window as any).__BASE_PATH__ || "";
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(`${basePath}/firebase-messaging-sw.js`)
    .then((reg) => console.log("Service Worker Registered:", reg))
    .catch((err) => console.log("Service Worker Registration Failed:", err));
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={(window as any).__BASE_PATH__ || ""}>
          <DehubThemeProvider themeOverride={invoiceThemeOverride}>
            <Notifications position="top-right" />
            <ModalsProvider modalProps={{ padding: 0 }}>
              <App />
            </ModalsProvider>
          </DehubThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
reportWebVitals();
